import Jb from "../assets/JBL GO3 pic.webp"
import GOe from "../assets/JBL-Go-3-shelf-shot--scaled.jpg"

export const Collection = [
    {
        Id: 1,
        url: Jb,
        desc: "A blue JBl speaker"
    },
    {
        Id: 2,
        url: GOe,
        desc: "A blue JBl here"
    },

]